export default "__VITE_ASSET__58006cc5__"